import React from 'react';
import { Box, CardMedia, Container, Stack, Typography } from '@mui/material';
import { useDevice } from '../../hooks/useResponsive';
import GradientCTAButton from './InspectionButton';

const InspectionService = () => {
  const { isMobile } = useDevice();

  return (
    <>
      <Container sx={{ pt: 6, pb: 5, px: isMobile ? 2 : 0.8, backgroundColor: 'white' }}>
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/pre-order.webp"
          alt="Card Image"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px' }}
        />
        <Stack pt={2} pb={3} pr={7} px={1.5}>
          <Typography color="#000000" fontSize={24} fontWeight={800} mb={1} lineHeight={1.2}>
            Buying a Pre-Owned Car? <br />
            Drive Home Confidence.
          </Typography>
          <Typography fontSize="11px" color="#000000" fontWeight="400" pr={5}>
            Book FOCUS Inspection Service and get your chosen car thoroughly inspected by certified experts—complete
            with warranty assurance.
          </Typography>
          <Box mt={2}>
            <Typography color="#000000" fontSize="11px">
              ✅ Thorough inspection by{' '}
              <Box component="span" fontWeight="bold">
                certified experts
              </Box>
            </Typography>
            <Typography color="#000000" fontSize="11px">
              🔧 Over
              <Box component="span" fontWeight="bold">
                {' '}
                130 quality checkpoints
              </Box>
            </Typography>
            <Typography color="#000000" fontSize="11px">
              🛡️ Complete with{' '}
              <Box component="span" fontWeight="bold">
                {' '}
                warranty assurance{' '}
              </Box>
            </Typography>
          </Box>
        </Stack>
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/130.webp"
          alt="Card Image"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px', mb: 4 }}
        />
        <GradientCTAButton text="Book Your Inspection Now" />
      </Container>
    </>
  );
};

export default InspectionService;
